import icons from './primitives/Icons'
import React from 'react'

import { Wrapper, ItemWrapper } from './Expertise.styles'

const Expertise = () => {
  return (
    <Wrapper>
      {icons.map((iconObj, i) => {
        const { text, Icon } = iconObj

        return (
          <ItemWrapper key={text + i}>
            <Icon />
            <p>{text}</p>
          </ItemWrapper>
        )
      })}
    </Wrapper>
  )
}

export default Expertise
